import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Styles from '../Style/Common.module.css';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import parse from 'html-react-parser';
import CustomButtonGroup from "../Common/CustomButtonGroup";

const Values = ({ data })=>{

  const valueSlide = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 3
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 580 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 580, min: 0 },
      items: 1
    }
  };
    return(
        <div className={'valuesSection ' + Styles.valueSec + " " + Styles.homeValue}>
          <Container fluid>
            <Row>
              <Col>
                <div className={Styles.valuesContainer}>
                  <h2 className={Styles.title} data-aos="fade-up" data-aos-delay="200">Guided by Values, Driven  by Trust  </h2>
                  <p className={Styles.subTitle} data-aos="fade-up" data-aos-delay="500">Integrity, Responsibility, Excellence, Pioneering, and Unity</p>
                  <div className={'navBtn ' + Styles.valueOwl} data-aos="fade-up" data-aos-delay="700">
                    <Carousel
                        autoPlaySpeed={2000}
                        transitionDuration={500}
                        responsive={valueSlide}
                        autoPlay={false}
                        infinite={true}
                        arrows={false}
                        customButtonGroup={<CustomButtonGroup />}
                        renderButtonGroupOutside={true}
                        containerClass="valueOwl"
                    >
                      {data && data.map((item, index) => (
                        <div className={Styles.valueSlide} key={index}>
                          <h4>{parse(item?.field1)}</h4>
                          <p>{parse(item?.field2)}</p>
                        </div>
                      ))}
                    </Carousel>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
    )
  }

export default Values;